import clsx from "clsx";
import { motion } from "motion/react";
import { type PropsWithChildren, useState } from "react";
import { useTranslations } from "use-intl";

import { Button } from "@/components/Button/Button";

type Props = PropsWithChildren;

export const ExpandableSection = ({ children }: Props) => {
  const t = useTranslations();

  const [isExpanded, setIsExpanded] = useState<boolean | null>(null);

  return (
    <>
      <motion.div
        initial={false}
        animate={{ height: isExpanded ? "auto" : 88 }}
        transition={{ duration: 0.4, ease: "easeInOut" }}
        className="relative mb-2 overflow-hidden"
      >
        {children}
        <div
          className={clsx(
            "absolute bottom-0 h-15 w-full bg-linear-to-b from-white/0",
            {
              "to-white/100": !isExpanded,
              "to-white/0": isExpanded,
            },
          )}
        />
      </motion.div>

      <Button
        variant="text"
        onClick={(e) => {
          setIsExpanded((prev) => !prev);
          e.currentTarget.blur();
        }}
        fullWidth
      >
        {isExpanded ? t("seeLess") : t("seeMore")}
      </Button>
    </>
  );
};
